module.exports = __webpack_public_path__ + "img/bgt.dbcd0659.png";